import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
  Input,
} from "reactstrap";

import Select from "react-select";
// redux
import { connect } from "react-redux";
// react router dom
import { useLocation } from "react-router-dom";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// services
import { getGroups } from "../../../utils/services/group";
import { editSchedule } from "../../../utils/services/schedule";
import { getUrlFiles } from "../../../utils/services/files";
import {
  listScheduleQuotas,
  updateScheduleQuotas,
  getListSessions,
} from "../../../utils/services/scheduleCotas";
// componentes
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import { getAllSpeakers } from "../../../utils/services/speaker";

function onImageChange(event, setStateFunction) {
  if (event.target.files && event.target.files[0]) {
    const reader = new FileReader();
    reader.onload = (e) => setStateFunction(e.target.result);
    reader.readAsDataURL(event.target.files[0]);
  }
}

function ImageField({ index, preview, setPreview, setImg }) {
  const inputId = `inputImage${index === 1 ? "" : index}`;
  return (
    <Row style={{ marginTop: index === 1 ? 20 : 10 }}>
      <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
        <label
          htmlFor="formFile"
          className="form-label"
          style={{ marginBottom: 0 }}
        >
          Imagem {index}
        </label>
        <label htmlFor={inputId} style={{ marginBottom: 0 }}>
          <i className="bx bx-pencil" style={{ cursor: "pointer" }} />
        </label>
        <input
          id={inputId}
          type="file"
          onChange={(e) => {
            onImageChange(e, setPreview);
            setImg(e.target.files?.[0]);
          }}
          style={{ display: "none" }}
        />
      </Col>
      <Col sm={6} style={{ display: "flex", alignItems: "center" }}>
        {preview && (
          <>
            <img alt="edit" src={preview} style={{ width: 70 }} />
            <i
              className="mdi mdi-trash-can icon-trash"
              style={{ marginLeft: 70 }}
              onClick={() => setPreview(null)}
            />
          </>
        )}
      </Col>
    </Row>
  );
}

function EditSchedule(props) {
  const { isOpen, toggle } = props;
  const location = useLocation();
  const token = props.state.global_user_data.data.token;

  // state de loading
  const [isLoading, setIsLoading] = useState(false);
  // confirmação de edição
  const [success_dlg, setsuccess_dlg] = useState(false);
  // state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  // state de grupos selecionados
  const [groupsMulti, setGroupsMulti] = useState([]);
  // state de foto
  const [photo, setPhoto] = useState(null);
  const [expires, setExpires] = useState(props.schedule?.expireDate);
  // state de data
  const [dateStart, setDateStart] = useState("");
  // state de palestrantes
  const [speakers, setSpeakers] = useState([]);
  const [allSpeakers, setAllSpeakers] = useState(false);
  const [speakersMulti, setSpeakersMulti] = useState([]);

  const [previewImg1, setPreviewImg1] = useState(
    props.schedule?.picture || null,
  );
  const [previewImg2, setPreviewImg2] = useState(
    props.schedule?.picture2 || null,
  );
  const [previewImg3, setPreviewImg3] = useState(
    props.schedule?.picture3 || null,
  );
  const [previewImg4, setPreviewImg4] = useState(
    props.schedule?.picture4 || null,
  );
  const [previewImg5, setPreviewImg5] = useState(
    props.schedule?.picture5 || null,
  );

  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [img3, setImg3] = useState(null);
  const [img4, setImg4] = useState(null);
  const [img5, setImg5] = useState(null);

  // state de erros
  const [titleError, setTitleError] = useState("");
  const [dateError, setDateError] = useState("");
  const [quotasError, setQuotasError] = useState("");
  const [hourStartError, setHourStartError] = useState("");
  const [hourEndError, setHourEndError] = useState("");

  const [backgroundColor, setBackgroundColor] = useState(props.schedule.color);
  const [isColorReady, setIsColorReady] = useState(false);
  const [amountQuotas, setAmountQuotas] = useState(0);

  const [startHour, setStartHour] = useState(props.schedule?.startHour);
  const [endHour, setEndHour] = useState(props.schedule?.endHour);
  const [title, setTitle] = useState(props.schedule?.title);
  const [description, setDescription] = useState(props.schedule?.description);
  const [order, setOrder] = useState(props.schedule.ordem ?? null);
  const [typeOrLocation, setTypeOrLocation] = useState(
    props.schedule?.typeOrLocation,
  );

  function checkProductExists(product) {
    if (location.state) {
      const search = location.state.event.product.filter(
        (e) => e.name === product,
      );
      if (search[0]) return true;
      else return false;
    }
  }

  const isComGas = () => checkProductExists("Distribuição de Cotas");
  const isApp = () => checkProductExists("APP Eventos Plus");
  const isRsvp = () => checkProductExists("RSVP");

  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  function handleSpeakersMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllSpeakers(true);
    } else {
      setAllSpeakers(false);
    }
    setSpeakersMulti(a);
  }

  async function createUrlImage(file) {
    let data = new FormData();
    data.append("files", file);
    data.append("folder", "agenda");
    data.append("eventId", props.idEvent);
    const response = await getUrlFiles(data, token);
    return response;
  }

  function formatDateTime(date, time) {
    return `${date}T${time || "00:01"}`;
  }

  async function getAvailableQuotas() {
    const res = await getListSessions(props.idEvent, token);
    const agendaAvailables = res.data.cotasManuais;

    if (agendaAvailables) {
      const pickAgenda = agendaAvailables.filter(
        (e) => e.agendaid === props.schedule.id,
      )[0];

      if (pickAgenda) {
        const usedManual = parseInt(pickAgenda.totalmanuais);
        const usedFechadas = parseInt(props.schedule.agendaCota.cotasFechadas);
        const usedSorteio = parseInt(props.schedule.agendaCota.cotasSorteio);
        let total = usedManual + usedFechadas + usedSorteio;
        total = total >= 1 ? total : 1;

        if (amountQuotas < total) {
          return { total, status: true };
        }
      }
      return { status: false };
    }
  }

  async function handleSubmit(e) {
    setTitleError("");
    setDateError("");
    setHourStartError("");
    setQuotasError("");
    setHourEndError("");

    if (title === "") {
      setTitleError("O campo Titulo é obrigatório.");
      return;
    }

    if (dateStart === "") {
      setDateError("O campo Data é obrigatório.");
      return;
    }

    const hasStartHour = startHour && startHour !== "";
    const hasEndHour = endHour && endHour !== "";

    if (dateStart && !hasStartHour && hasEndHour) {
      setHourStartError("O campo Hora Inicio deve ser informado.");
      return;
    }

    if (dateStart && hasStartHour && hasEndHour && endHour < startHour) {
      setHourEndError("O campo Hora Fim deve ser maior que Hora Início.");
      return;
    }

    const hasCotas = checkProductExists("Distribuição de Cotas");

    if (hasCotas && !amountQuotas) {
      setQuotasError("O campo Quantidade de Cotas é obrigatório");
      return;
    }

    if (hasCotas) {
      const checkMin = await getAvailableQuotas();
      if (checkMin.status) {
        setQuotasError(
          `A quantidade de cotas informada é menor do que o valor de cotas já distribuídas. A quantidade precisa ser maior ou igual a ${checkMin.total}`,
        );
        return;
      }
    }

    // upload paralelo de imagens
    let pictures = [
      { image: previewImg1 },
      { image: previewImg2 },
      { image: previewImg3 },
      { image: previewImg4 },
      { image: previewImg5 },
    ];
    let expiresDate = expires;

    if (isApp() || isRsvp()) {
      const imageFiles = [img1, img2, img3, img4, img5];
      const uploads = await Promise.all(
        imageFiles.map(async (img, i) => {
          if (img && img.type.startsWith("image/")) {
            const resp = await createUrlImage(img);
            return { index: i, url: resp[0]?.url, expires: resp[0]?.expires };
          }
          return null;
        }),
      );
      uploads.forEach((result) => {
        if (result) {
          pictures[result.index] = { image: result.url };
          expiresDate = result.expires;
        }
      });
    }

    if (!img1 && !img2 && !img3 && !img4 && !img5) {
      const allEmpty = pictures.every((item) => !item.image);
      if (allEmpty) expiresDate = null;
    }

    const groupsArray = [];
    const speakersArray = [];

    if (allGroups) {
      groups.forEach((e) => groupsArray.push(e.id));
    } else {
      groupsMulti.forEach((e) => groupsArray.push(e.value));
    }

    if (allSpeakers) {
      speakers.forEach((e) => speakersArray.push(e.id));
    } else {
      speakersMulti.forEach((e) => speakersArray.push(e.value));
    }

    setIsLoading(true);

    try {
      const data = await editSchedule({
        eventId: props.idEvent,
        startDate: formatDateTime(dateStart, startHour),
        startHour,
        endHour,
        title,
        description,
        typeOrLocation,
        color: backgroundColor,
        picture: pictures[0]?.image || null,
        picture2: pictures[1]?.image || null,
        picture3: pictures[2]?.image || null,
        picture4: pictures[3]?.image || null,
        picture5: pictures[4]?.image || null,
        expireDate: expiresDate,
        ordem: order ? Number(order) : null,
        groups: groupsArray,
        jwt: token,
        id: props.schedule.id,
        palestrantes: speakersArray,
      });

      if (data?.message === "AGENDA_UPDATED") {
        if (isComGas()) {
          await updateScheduleQuotas({
            id: data.agenda.id,
            qtdCotas: amountQuotas,
            jwt: token,
          });
        }
        setsuccess_dlg(true);
      }
    } finally {
      setIsLoading(false);
    }
  }

  function formatData(e) {
    const result = e.split("T");
    setDateStart(result[0]);
  }

  async function getGroupsFunc() {
    await getGroups({
      jwt: token,
      eventId: props.idEvent,
      offset: 1,
      limit: 0,
      search: "",
    })
      .then((response) => {
        setGroups(response.findOneGroupData.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  function funcGroups() {
    let groupsArray = [];
    if (groups?.length > 0) {
      props.schedule.groups.forEach((a) => {
        groups.forEach((e) => {
          if (e.id === a.grupoId) {
            groupsArray.push({ label: e.name, value: e.id });
          }
        });
      });
      if (groups?.length === groupsArray.length) {
        groupsArray = [];
        groupsArray.push({ label: "TODOS", value: "todos" });
        setAllGroups(true);
      }
    }
    setGroupsMulti(groupsArray);
  }

  function getSpeakers() {
    getAllSpeakers(props.idEvent, 1, 999, "", "").then((res) => {
      if (res.data.message === "findAllPalestrantes") {
        setSpeakers(res.data.findAllPalestrantes.data);
        // setCountData(res.data.findAllPalestrantes.count);
      }
    });
  }

  function funcSpeakers() {
    let speakersArray = [];

    if (props.schedule?.palestrantes?.length > 0) {
      props.schedule?.palestrantes.forEach((a) => {
        speakersArray.push({ label: a.name, value: a.id });
      });

      if (speakers?.length === speakersArray?.length) {
        speakersArray = [];
        speakersArray.push({ label: "TODOS", value: "todos" });
        setAllSpeakers(true);
      }
    }
    setSpeakersMulti(speakersArray);
  }

  async function getListScheduleQuotas() {
    await listScheduleQuotas({
      id: props.schedule.id,
      event: props.idEvent,
      jwt: token,
    })
      .then((response) => {
        if (response.data?.agendaCota) {
          setAmountQuotas(response.data.agendaCota.qtdCotas);
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  useEffect(() => {
    if (isOpen) {
      setIsColorReady(false);
      getGroupsFunc();
      formatData(props.schedule.startDate);
      getListScheduleQuotas();
      setTimeout(() => setIsColorReady(true), 0);
    }
  }, [isOpen]);

  useEffect(() => {
    funcGroups();
  }, [groups]);

  useEffect(() => {
    getSpeakers();
  }, []);

  useEffect(() => {
    funcSpeakers();
  }, [speakers]);

  const imageFields = [
    { preview: previewImg1, setPreview: setPreviewImg1, setImg: setImg1 },
    { preview: previewImg2, setPreview: setPreviewImg2, setImg: setImg2 },
    { preview: previewImg3, setPreview: setPreviewImg3, setImg: setImg3 },
    { preview: previewImg4, setPreview: setPreviewImg4, setImg: setImg4 },
    { preview: previewImg5, setPreview: setPreviewImg5, setImg: setImg5 },
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} autoFocus={true} centered={true}>
      {success_dlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            props.refetch();
            setsuccess_dlg(false);
            toggle();
          }}
        >
          {"Programação editada com sucesso!"}
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Editar Programação</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">ID da Agenda</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.schedule.id}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Titulo*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.schedule.title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {titleError && (
                  <span style={{ color: "red" }}>{titleError}</span>
                )}
              </div>
            </Col>
          </Row>

          {(isApp() || isRsvp()) && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Descrição</label>
                  <textarea
                    className="form-control"
                    type="text"
                    defaultValue={props.schedule.description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Data da Programação*</label>
                <input
                  className="form-control"
                  type="date"
                  id="example-datetime-local-input"
                  value={dateStart}
                  onChange={(e) => formatData(e.target.value)}
                />
                {dateError && <span style={{ color: "red" }}>{dateError}</span>}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={6}>
              <div>
                <label className="form-label">Hora Início</label>
                <input
                  className="form-control"
                  type="time"
                  id="start-datetime-local-input"
                  defaultValue={props.schedule.startHour}
                  onChange={(e) => setStartHour(e.target.value)}
                />
                <span style={{ color: "red" }}>{hourStartError}</span>
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <label className="form-label">Hora Fim</label>
                <input
                  className="form-control"
                  type="time"
                  id="end-datetime-local-input"
                  defaultValue={props.schedule.endHour}
                  onChange={(e) => setEndHour(e.target.value)}
                />
                <span style={{ color: "red" }}>{hourEndError}</span>
              </div>
            </Col>
          </Row>

          {(isApp() || isRsvp()) && (
            <>
              {imageFields.map((imgProps, i) => (
                <ImageField key={i} index={i + 1} {...imgProps} />
              ))}

              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">
                      Tipo/Local da Programação
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      defaultValue={props.schedule.typeOrLocation}
                      onChange={(e) => setTypeOrLocation(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  {isColorReady && (
                    <ColorPicker
                      classOfContainer="bg-edit-shedule-event-pickr"
                      labelText="Cor da Programação"
                      setStateFunc={setBackgroundColor}
                      defaultColor={backgroundColor}
                    />
                  )}
                </Col>
              </Row>
            </>
          )}

          {isComGas() && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Quantidade de Cotas*</label>
                  <input
                    className="form-control"
                    type="number"
                    value={amountQuotas}
                    onChange={(e) => setAmountQuotas(e.target.value)}
                    min={1}
                  />
                  {quotasError && (
                    <span style={{ color: "red" }}>{quotasError}</span>
                  )}
                </div>
              </Col>
            </Row>
          )}

          {(isApp() || isRsvp()) && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Ordem</label>
                    <input
                      className="form-control"
                      type="number"
                      onChange={(e) => setOrder(e.target.value)}
                      value={order}
                    />
                  </div>
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">Palestrantes</label>
                    <Select
                      value={speakersMulti}
                      placeholder={"Selecione"}
                      isMulti={true}
                      onChange={(e) => {
                        handleSpeakersMulti(e);
                      }}
                      noOptionsMessage={() => "Nenhuma opção encontrada"}
                      options={[
                        {
                          options:
                            speakers.length > 0 && !allSpeakers
                              ? [
                                  { label: "TODOS", value: "todos" },
                                  ...speakers.map((e) => {
                                    return { label: e.name, value: e.id };
                                  }),
                                ]
                              : [],
                        },
                      ]}
                      classNamePrefix="select2-selection"
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  value={groupsMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleGroupMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        groups.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "20px auto 0 auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button color="danger" style={{ width: 80 }} onClick={toggle}>
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              action="U"
              marginLeft={10}
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(EditSchedule);
